module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/forget-password/forget-password.component.css
// module id = ./src/app/forget-password/forget-password.component.css
// module chunks = main